import { CardWrap } from '../styles';
import { TGlossary_Card } from '../utils/types';
import { formateDate } from '../utils/utils';
export const Card = ({
  categoryData,
}: {
  categoryData: TGlossary_Card[];
}): JSX.Element => {
  return (
    <>
      <CardWrap className="grid sm:grid-cols-1 md:grid-cols-2 grid-cols-3 gap-5 mb-8">
        {categoryData?.map((item, index) => {
          return (
            <div
              key={index}
              className="pt-8 pb-12 px-6 rounded-xl"
              style={{
                boxShadow: '0px 10px 20px 0px rgba(164, 172, 178, 0.12)',
              }}
            >
              <h5 className="mb-4">
                <a
                  className="sm:text-s-18 text-s-24 text-font-500 hover:text-blue-350 font-bold "
                  href={`/glossary/${item['SEO_term']}`}
                >
                  {item.H1_1}
                </a>
              </h5>
              <p className="text-grey-970 text-s-14 mb-6">
                {formateDate(item.updated_at)}
              </p>
              <p
                className="text-base"
                style={{
                  WebkitLineClamp: 4,
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
                dangerouslySetInnerHTML={{ __html: item.Markdown }}
              />
            </div>
          );
        })}
      </CardWrap>
    </>
  );
};
